import Account from "@/views/Account.vue";
import SimpleVendorSetup from "@/views/open/SimpleVendorSetup.vue";
import VendorSetupConfirmation from "@/views/open/VendorSetupConfirmation.vue";
import ContentHeader from "@/views/ContentHeader";
import ProofOfEnrollment from "@/views/customers/ProofOfEnrollment.vue";
import { VENDOR_ROLE, CLIENT_ROLE } from "@/services/constants";
import VendorLogin from "@/views/vendor/VendorLogin.vue";
import CreateAccount from "@/views/account/CreateAccount.vue";
import Standards from "@/pds/Standards.vue";

var proofOfEnrollmentRoute = {
  path: "/poc/:customerId/:vendorId",
  name: "poc",
  component: ProofOfEnrollment,
  props: true,
  meta: {
    humanName: "Proof of Enrollment",
    navbar: false
  }
};

var simpleVendorSetupRoute = {
  path: "/vendor-setup/:clientTag",
  name: "simpleVendorSetup",
  component: SimpleVendorSetup,
  props: true,
  meta: {
    humanName: "Vendor Setup",
    navbar: false
  }
};

var vendorSetupConfirmationRoute = {
  path: "/vendor-setup-confirmation/:clientTag",
  name: "VendorSetupConfirmation",
  component: VendorSetupConfirmation,
  props: true,
  meta: {
    humanName: "Vendor Setup Successful",
    navbar: false
  }
};

var accountRoute = {
  path: "/account",
  component: Account,
  props: true,
  meta: {
    humanName: "Account Home",
    role: [VENDOR_ROLE, CLIENT_ROLE]
  },
  children: [
    {
      path: "/",
      name: "account",
      meta: {
        humanName: "My Account",
        role: [VENDOR_ROLE, CLIENT_ROLE]
      },
      component: ContentHeader,
      props: {
        headerIcon: "mdi-account-circle-outline",
        headerTitle: "Account"
      }
    }
  ]
};

var vendorLoginRoute = {
  path: "/vendor/login",
  name: "VendorLogin",
  component: VendorLogin,
  props: false,
  meta: {
    title: "Vendor Login | VendorProof",
    humanName: "Vendor Login",
    navbar: false,
    footer: true
  }
};

var createVendorAccountRoute = {
  path: "/vendor/create-account",
  name: "CreateAccount",
  component: CreateAccount,
  meta: {
    title: "Vendor Create Account",
    humanName: "Create Account",
    navbar: false,
    footer: true
  }
};

const standardsRoute = {
  path: "/standards",
  name: "standards",
  component: Standards,
  meta: {
    humanName: "Standards",
    footer: true
  }
};

export const defaultUniversalRoute = {
  path: "/client-login",
  name: "loginRedirect",
  href: "client/login",
  meta: { redirect: "client/login" }
};

export const UniversalRoutes = [
  proofOfEnrollmentRoute,
  simpleVendorSetupRoute,
  vendorSetupConfirmationRoute,
  defaultUniversalRoute,
  accountRoute,
  vendorLoginRoute,
  createVendorAccountRoute,
  standardsRoute
];
